import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_65e5f37e from 'nuxt_plugin_plugin_65e5f37e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_5f4cf8e0 from 'nuxt_plugin_appplugin_5f4cf8e0' // Source: ../../@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_a4a0dffa from 'nuxt_plugin_recaptcha_a4a0dffa' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_templatesplugind431ce70_7aadf04a from 'nuxt_plugin_templatesplugind431ce70_7aadf04a' // Source: ./templates.plugin.d431ce70.js (mode: 'all')
import nuxt_plugin_capiplugin_7b33377f from 'nuxt_plugin_capiplugin_7b33377f' // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_image_9a9c2ee2 from 'nuxt_plugin_image_9a9c2ee2' // Source: ./image.js (mode: 'all')
import nuxt_plugin_deviceplugin_1bb7af1f from 'nuxt_plugin_deviceplugin_1bb7af1f' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_angieui_cf116268 from 'nuxt_plugin_angieui_cf116268' // Source: ../../../plugins/angie-ui.ts (mode: 'all')
import nuxt_plugin_filters_2dd71148 from 'nuxt_plugin_filters_2dd71148' // Source: ../../../plugins/filters.ts (mode: 'all')
import nuxt_plugin_mixins_9ca861b6 from 'nuxt_plugin_mixins_9ca861b6' // Source: ../../../plugins/mixins.ts (mode: 'all')
import nuxt_plugin_analyticsclient_ed907838 from 'nuxt_plugin_analyticsclient_ed907838' // Source: ../../../plugins/analytics.client.ts (mode: 'client')
import nuxt_plugin_growthbookclient_6a346cba from 'nuxt_plugin_growthbookclient_6a346cba' // Source: ../../../plugins/growthbook.client.ts (mode: 'client')
import nuxt_plugin_vuemodalclient_1e1f9c04 from 'nuxt_plugin_vuemodalclient_1e1f9c04' // Source: ../../../plugins/vue-modal.client.ts (mode: 'client')
import nuxt_plugin_eComm_ea689c1c from 'nuxt_plugin_eComm_ea689c1c' // Source: ../../../plugins/eComm.ts (mode: 'all')
import nuxt_plugin_apiClient_ae47a604 from 'nuxt_plugin_apiClient_ae47a604' // Source: ../../../plugins/apiClient.ts (mode: 'all')
import nuxt_plugin_customerioclient_44f1400e from 'nuxt_plugin_customerioclient_44f1400e' // Source: ../../../plugins/customerio.client.ts (mode: 'client')
import nuxt_plugin_initAppclient_9292e7e2 from 'nuxt_plugin_initAppclient_9292e7e2' // Source: ../../../plugins/initApp.client.ts (mode: 'client')
import nuxt_plugin_eventBusclient_e0f4d9e0 from 'nuxt_plugin_eventBusclient_e0f4d9e0' // Source: ../../../plugins/eventBus.client.ts (mode: 'client')
import nuxt_plugin_pageGuardsclient_3bc2f527 from 'nuxt_plugin_pageGuardsclient_3bc2f527' // Source: ../../../plugins/pageGuards.client.ts (mode: 'client')
import nuxt_plugin_ordersApi_6cf23c8e from 'nuxt_plugin_ordersApi_6cf23c8e' // Source: ../../../plugins/ordersApi.ts (mode: 'all')
import nuxt_plugin_bugSnagclient_1955e473 from 'nuxt_plugin_bugSnagclient_1955e473' // Source: ../../../plugins/bugSnag.client.ts (mode: 'client')
import nuxt_plugin_swiperclient_d20335fc from 'nuxt_plugin_swiperclient_d20335fc' // Source: ../../../plugins/swiper.client.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"FightCamp","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"preconnect","href":"\u002F\u002Fcdn.joinfightcamp.com"},{"rel":"preconnect","href":"\u002F\u002Fcdn-b.joinfightcamp.com"},{"rel":"preconnect","href":"\u002F\u002Fjs.stripe.com"},{"rel":"preconnect","href":"\u002F\u002Fwww.googletagmanager.com"},{"rel":"preconnect","href":"\u002F\u002Fcdn.segment.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn.joinfightcamp.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn-b.joinfightcamp.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn3.joinfightcamp.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn1-sandbox.affirm.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fjs.stripe.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn.segment.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn1.affirm.com"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fapple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fapple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-icon-180x180.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Fandroid-icon-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"}],"script":[{"src":"https:\u002F\u002Fcdn.cookielaw.org\u002Fconsent\u002F46a57cfd-95f5-4b6c-8084-4988c285f9ea\u002FOtAutoBlock.js","body":false,"defer":false,"async":false,"type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fcdn.cookielaw.org\u002Fscripttemplates\u002FotSDKStub.js","body":false,"defer":false,"async":false,"type":"text\u002Fjavascript","charset":"UTF-8","data-domain-script":"46a57cfd-95f5-4b6c-8084-4988c285f9ea"},{"innerHTML":"function OptanonWrapper() { }","type":"text\u002Fjavascript"},{"body":false,"defer":true,"src":"data:text\u002Fjavascript,(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl+ '&gtm_auth=miv05EkVSnjqAUqIhrKmLA&gtm_preview=env-2&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-WQQXMXZ');"},{"body":true,"defer":true,"src":"data:text\u002Fjavascript,window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\ngtag('config', 'AW-753449862');"},{"defer":true,"body":true,"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"defer":true,"body":true,"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-753449862"},{"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fapi.js","async":true,"defer":true},{"body":false,"defer":true,"type":"text\u002Fjavascript","innerHTML":"\n      !function(){var i=\"cioanalytics\", analytics=(window[i]=window[i]||[]);if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\",\"addSourceMiddleware\",\"addIntegrationMiddleware\",\"setAnonymousId\",\"addDestinationMiddleware\"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e\u003Canalytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement(\"script\");t.type=\"text\u002Fjavascript\";t.async=!0;t.setAttribute('data-global-customerio-analytics-key', i);t.src=\"https:\u002F\u002Fcdp.customer.io\u002Fv1\u002Fanalytics-js\u002Fsnippet\u002F\" + key + \"\u002Fanalytics.min.js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(t,n);analytics._writeKey=key;analytics._loadOptions=e};analytics.SNIPPET_VERSION=\"4.15.3\";\n        analytics.load(\"158596c30e1f256c6abe\");\n        analytics.page();\n      }}();\n    "}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_65e5f37e === 'function') {
    await nuxt_plugin_plugin_65e5f37e(app.context, inject)
  }

  if (typeof nuxt_plugin_appplugin_5f4cf8e0 === 'function') {
    await nuxt_plugin_appplugin_5f4cf8e0(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_a4a0dffa === 'function') {
    await nuxt_plugin_recaptcha_a4a0dffa(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugind431ce70_7aadf04a === 'function') {
    await nuxt_plugin_templatesplugind431ce70_7aadf04a(app.context, inject)
  }

  if (typeof nuxt_plugin_capiplugin_7b33377f === 'function') {
    await nuxt_plugin_capiplugin_7b33377f(app.context, inject)
  }

  if (typeof nuxt_plugin_image_9a9c2ee2 === 'function') {
    await nuxt_plugin_image_9a9c2ee2(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_1bb7af1f === 'function') {
    await nuxt_plugin_deviceplugin_1bb7af1f(app.context, inject)
  }

  if (typeof nuxt_plugin_angieui_cf116268 === 'function') {
    await nuxt_plugin_angieui_cf116268(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71148 === 'function') {
    await nuxt_plugin_filters_2dd71148(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_9ca861b6 === 'function') {
    await nuxt_plugin_mixins_9ca861b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsclient_ed907838 === 'function') {
    await nuxt_plugin_analyticsclient_ed907838(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_growthbookclient_6a346cba === 'function') {
    await nuxt_plugin_growthbookclient_6a346cba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemodalclient_1e1f9c04 === 'function') {
    await nuxt_plugin_vuemodalclient_1e1f9c04(app.context, inject)
  }

  if (typeof nuxt_plugin_eComm_ea689c1c === 'function') {
    await nuxt_plugin_eComm_ea689c1c(app.context, inject)
  }

  if (typeof nuxt_plugin_apiClient_ae47a604 === 'function') {
    await nuxt_plugin_apiClient_ae47a604(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_customerioclient_44f1400e === 'function') {
    await nuxt_plugin_customerioclient_44f1400e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initAppclient_9292e7e2 === 'function') {
    await nuxt_plugin_initAppclient_9292e7e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventBusclient_e0f4d9e0 === 'function') {
    await nuxt_plugin_eventBusclient_e0f4d9e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pageGuardsclient_3bc2f527 === 'function') {
    await nuxt_plugin_pageGuardsclient_3bc2f527(app.context, inject)
  }

  if (typeof nuxt_plugin_ordersApi_6cf23c8e === 'function') {
    await nuxt_plugin_ordersApi_6cf23c8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugSnagclient_1955e473 === 'function') {
    await nuxt_plugin_bugSnagclient_1955e473(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperclient_d20335fc === 'function') {
    await nuxt_plugin_swiperclient_d20335fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
